import Alpine from "alpinejs";

export default (id) => ({
  serverTimestamp: null,
  init() {
    const self = this;
    this.$watch("$store.serverTimestamp", (value) => {
      self.serverTimestamp = value || null;
    });
  },
  get lot() {
    return Alpine.store(`lot${id}`);
  },
  // Attributes
  get startTimestamp() {
    return this.lot.startTimestamp;
  },
  get endTimestamp() {
    return this.lot.endTimestamp;
  },
  // State
  get isLoading() {
    return this.serverTimestamp === null;
  },
  get isOpening() {
    return (
      this.serverTimestamp !== null &&
      this.startTimestamp > this.serverTimestamp
    );
  },
  get isOpen() {
    return (
      this.serverTimestamp !== null &&
      this.startTimestamp <= this.serverTimestamp &&
      this.serverTimestamp <= this.endTimestamp
    );
  },
  get isExpiring () {
    if (this.serverTimestamp === null) {
      return false;
    } else {
      return (this.endTimestamp - this.serverTimestamp) < 300 * 1000;
    }
  },
  get isClosed() {
    return (
      this.serverTimestamp !== null &&
      this.serverTimestamp > this.endTimestamp
    );
  },
  // Timer
  get countdownTimer() {
    const diff = this.serverTimestamp !== null
      ? Math.max(0, this.endTimestamp - this.serverTimestamp)
      : 0;
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = String(Math.floor(
      (diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    )).padStart(2, '0');
    const minutes = String(Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, "0");
    const seconds = String(Math.floor((diff % (1000 * 60)) / 1000)).padStart(2, "0");

    var formatted = `${hours}:${minutes}:${seconds}`;
    if (days > 0) {
      return `${days}d ${formatted}`;
    }
    return formatted;
  }
});
